module.exports = __webpack_public_path__ + "img/exit-icon.3ed30d1d.png";